import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import moment from "moment";
import { days_ago } from 'src/utils/CommonUtils';

const TaskTable = ({ onEdit, filterSearch, assignee,taskId, onDelete }) => {
  // Table Scroll Code Start
  const elementRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const debounceTimeoutRef = useRef(null); // Store the debounce timeout ID
  const {
    search: { data = [] } = {},
    hierarchy = [],
  } = useSelector((state) => state.ScheduleTaskReducer, shallowEqual);
  // Apply filtering logic
  // const filteredRows = data
  //   .map((subtask, index) => {
  //     // Find hierarchy entries where current subtask is the parent
  //     const childLink = hierarchy.find(
  //       h => h.parentSubTaskId?.toString() === subtask._id?.toString()
  //     );
  //     // If match found, get subTaskName of the child subtask
  //     const dependentSubtaskName = childLink
  //       ? data.find(d => d._id?.toString() === childLink.subTaskId?.toString())?.subTaskName
  //       : '';
  //     return {
  //       key: index,
  //       taskName: subtask.taskId?.taskName || '',
  //       dependentSubtaskName: dependentSubtaskName,
  //       ...subtask
  //     };
  //   })
  //   .filter((row) => {
  //     const matchSearch =
  //       !filterSearch ||
  //       row.taskName.toLowerCase().includes(filterSearch.toLowerCase()) ||
  //       row.subTaskName.toLowerCase().includes(filterSearch.toLowerCase());

  //     const matchAssignee = !assignee || row.assignTo === assignee;

  //     return matchSearch && matchAssignee;
  //   });
  const seen = new Set();

  const filteredRows = (data || [])
    // .filter((item) => {
    //   const id = item._id?.toString();
    //   const isDependency = item.initiationType === "Dependency";
    //   const isFixed = item.initiationType === "Fixed";

    //   const isInHierarchy =
    //     !hierarchy?.length ||
    //     hierarchy.some(h => h.subTaskId?.toString() === id);

    //   const isUnique = !seen.has(id) && (isFixed || (isDependency && isInHierarchy));
    //   if (isUnique) seen.add(id);
    //   return isUnique;
    // })
    .filter((subtask) => !taskId || subtask.taskId?._id?.toString() === taskId)
    .map((subtask, index) => {
      // Find parentSubTaskId from hierarchy
      const hierarchyEntry = hierarchy.find(
        h => h.subTaskId?.toString() === subtask._id?.toString()
      );
      const parentId = hierarchyEntry?.parentSubTaskId?.toString();

      // Find parent subtask name
      const parent = parentId
        ? data.find(d => d._id?.toString() === parentId)
        : null;

      return {
        key: index,
        taskName: subtask.taskId?.taskName || '',
        dependentSubtaskName: parent?.subTaskName || '',
        ...subtask
      };
    })
    .filter((row) => {
      const matchSearch =
        !filterSearch ||
        row.taskName.toLowerCase().includes(filterSearch.toLowerCase()) ||
        row.subTaskName.toLowerCase().includes(filterSearch.toLowerCase());

      // const matchAssignee = !assignee || row.assignTo === assignee;
      const matchAssignee =
        !assignee ||
        (assignee === 'Self'
          ? row.assignTo === 'Self'
          : (row.users || []).some(u => u._id === assignee));

      return matchSearch && matchAssignee;
    });
  useEffect(() => {
    const handleScroll = () => {
      // Clear the previous timeout to prevent multiple updates
      clearTimeout(debounceTimeoutRef.current);

      debounceTimeoutRef.current = setTimeout(() => {
        if (elementRef.current) {
          const { top, bottom } = elementRef.current.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

          // Check if the table <thead> is within the viewport range
          const shouldScroll = top <= 100 && bottom >= viewportHeight - 100;
          setIsScrollable(shouldScroll);
        }
      }, 100); // Adjust the debounce delay as needed (e.g., 100ms)
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(debounceTimeoutRef.current); // Cleanup on unmount
    };
  }, []);
  return (
    <div className={`table-body-scrollable ${isScrollable ? 'scrollable' : ''}`}>
      <table className="table basic-border-table mb-0 table-hover" ref={elementRef}>
        <thead className="table-light">
          <tr>
            <th>Project</th>
            <th>Task</th>
            <th>Assigned to</th>
            <th>Frequency</th>
            <th>Days</th>
            {/* <th>Initiation Type</th> */}
            <th>Scheduled Time</th>
            {/* <th>Dependent Subtask</th> */}
            {/* <th>Duration</th> */}
            <th>Created At</th>
            <th>Pending Since</th>
            <th className='text-center'>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredRows.map((row, index) => (
            <tr key={row.key}>
              <td>
                {row.taskName}
              </td>
              <td>{row.subTaskName}</td>
              <td>{(row.assignTo) === "Other" ? row.users?.map(u => u.firstName + " " + u.lastName).join(', ') : row.assignTo || ""}</td>
              <td>{row.frequency}</td>
              <td>{((row.frequency !== "Monthly" ? row.selectedDays : row.selectedMonthDates) || []).join(' ')}</td>
              {/* <td>{row.initiationType}</td> */}
              <td>{row.time}</td>
              {/* <td>{row.dependentSubtaskName}</td> */}
              {/* <td>{`${row.duration} ${row.durationUnit}`}</td> */}
               <td>{moment(row.ts).format("DD-MM-YYYY hh:mm A")}</td>
               <td>{days_ago(row.ts)}</td>
              <td>
                <button className="px-10 py-4 border-0 me-1 text-primary" onClick={() => onEdit(data,row)}>
                  <i className="mdi mdi-border-color mdi-24px"></i>
                </button>
                <button
                  className="px-10 py-4 border-0 text-danger"
                  onClick={() => onDelete(row)}
                >
                  <i className="mdi mdi-delete mdi-24px"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskTable;
